module.exports = __webpack_public_path__ + "media/blinking_looc.116dddbf.mp4";